import { AvailableSavingsResponse, OSEnum } from '@cast/types';

const savingsResponse: AvailableSavingsResponse = {
  isRebalancingRecommended: false,
  recommendations: {
    Layman: {
      monthly: { priceBefore: '131.438376000', priceAfter: '117.544867200' },
      hourly: { priceBefore: '0.182553300', priceAfter: '0.163256760' },
      savingsPercentage: '10.5703594500',
      details: {
        armSavingsConfiguration: {
          nodes: [
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              spot: false,
              fallback: false,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-1',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 2,
              az: 'us-east1-b',
              nodeName: 'node-2',
              os: OSEnum.linux,
            },
          ],
          summary: {
            cpuCores: 4,
            distinctNodeTypes: 1,
            ramBytes: 2 * 2147483648,
            gpu: 2,
            nodes: 2,
          },
        },
        configurationAfter: {
          nodes: [
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              spot: false,
              fallback: false,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-1',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 2,
              az: 'us-east1-b',
              nodeName: 'node-2',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-3',
              os: OSEnum.linux,
            },
          ],
          summary: {
            cpuCores: 6,
            distinctNodeTypes: 1,
            ramBytes: 6442450944,
            gpu: 2,
            nodes: 3,
          },
        },
        replicatedWorkload: {},
        replicatedWorkloads: [],
      },
    },
    SpotInstances: {
      monthly: { priceBefore: '131.438376000', priceAfter: '90.117731520' },
      hourly: { priceBefore: '0.182553300', priceAfter: '0.125163516' },
      savingsPercentage: '31.4372755800',
      details: {
        armSavingsConfiguration: {
          nodes: [
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 1,
              az: 'us-east1-b',
              nodeName: 'node-1',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 1,
              az: 'us-east1-b',
              nodeName: 'node-2',
              os: OSEnum.linux,
            },
          ],
          summary: {
            cpuCores: 4,
            distinctNodeTypes: 1,
            ramBytes: 2 * 2147483648,
            gpu: 2,
            nodes: 2,
          },
        },
        configurationAfter: {
          nodes: [
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 1,
              az: 'us-east1-b',
              nodeName: 'node-1',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 1,
              az: 'us-east1-b',
              nodeName: 'node-2',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.016325676',
              ramBytes: 2147483648,
              fallback: false,
              spot: true,
              gpu: 1,
              az: 'us-east1-b',
              nodeName: 'node-3',
              os: OSEnum.linux,
            },
          ],
          summary: {
            cpuCores: 6,
            distinctNodeTypes: 1,
            ramBytes: 6442450944,
            gpu: 3,
            nodes: 3,
          },
        },
        replicatedWorkload: {},
        replicatedWorkloads: [],
      },
    },
    SpotOnly: {
      monthly: { priceBefore: '131.438376000', priceAfter: '90.117731520' },
      hourly: { priceBefore: '0.182553300', priceAfter: '0.125163516' },
      savingsPercentage: '31.4372755800',
      details: {
        armSavingsConfiguration: {
          nodes: [
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-1',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-2',
              os: OSEnum.linux,
            },
          ],
          summary: {
            cpuCores: 4,
            distinctNodeTypes: 1,
            ramBytes: 2 * 2147483648,
            gpu: 0,
            nodes: 2,
          },
        },
        configurationAfter: {
          nodes: [
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-1',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.054418920',
              ramBytes: 2147483648,
              fallback: false,
              spot: false,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-2',
              os: OSEnum.linux,
            },
            {
              cpuCores: 2,
              instanceType: 'e2-highcpu-2',
              price: '0.016325676',
              ramBytes: 2147483648,
              fallback: false,
              spot: true,
              gpu: 0,
              az: 'us-east1-b',
              nodeName: 'node-3',
              os: OSEnum.linux,
            },
          ],
          summary: {
            cpuCores: 6,
            distinctNodeTypes: 1,
            ramBytes: 6442450944,
            gpu: 0,
            nodes: 3,
          },
        },
        replicatedWorkload: {},
        replicatedWorkloads: [],
      },
    },
  },
  currentConfiguration: {
    nodes: [
      {
        cpuCores: 2,
        instanceType: 'e2-medium',
        price: '0.060851100',
        ramBytes: 4294967296,
        fallback: false,
        spot: false,
        gpu: 1,
        az: 'us-east1-b',
        nodeName: 'node-1',
        os: OSEnum.linux,
      },
      {
        cpuCores: 2,
        instanceType: 'e2-medium',
        price: '0.060851100',
        ramBytes: 4294967296,
        fallback: false,
        spot: false,
        gpu: 1,
        az: 'us-east1-b',
        nodeName: 'node-2',
        os: OSEnum.linux,
      },
      {
        cpuCores: 2,
        instanceType: 'e2-medium',
        price: '0.060851100',
        ramBytes: 4294967296,
        fallback: false,
        spot: false,
        gpu: 1,
        az: 'us-east1-b',
        nodeName: 'node-3',
        os: OSEnum.linux,
      },
    ],
    totalPrice: { hourly: '0.182553300', monthly: '131.438376000' },
    workloads: [],
  },
};

export const estimatedSavingsFixtures = {
  savings: {
    response: savingsResponse,
  },
  workloads: [
    {
      name: 'castai-agent-5997879766',
      ownerType: 'ReplicaSet',
      currentNodeType: 'onDemand',
      recommendedNodeType: 'onDemand',
      replicas: 1,
    },
    {
      name: 'coredns-7cfc675d7d',
      ownerType: 'ReplicaSet',
      currentNodeType: 'onDemand',
      recommendedNodeType: 'onDemand',
      replicas: 2,
    },
  ],
  workloadsExport: [
    '"Workloads","Replicas","Current type","Suggested type"',
    '"castai-agent-5997879766","1","onDemand","onDemand"',
    '"coredns-7cfc675d7d","2","onDemand","onDemand"',
  ].join('\r\n'),
};
